
const firstGradientBgEl = document.querySelector('.first-sec-bg');
const firstIndexSecEl = document.querySelector('.first-index-page');

if (firstGradientBgEl && firstIndexSecEl) {
  const firstSecHeight = firstIndexSecEl.offsetHeight;
  firstGradientBgEl.style.setProperty(
    '--first-sec-height',
    `${firstSecHeight}px`
  );

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          import('./gradient.component.js').then(({ Gradient }) => {
            const gradient = new Gradient();
            gradient.initGradient('#gradient-canvas');
          });

          obs.disconnect();
        }
      });
    },
    { threshold: 0.1 }
  );

  observer.observe(firstIndexSecEl);
}